export default __webpack_public_path__ + "static/media/blue-giftcard.dca9947f.svg";